import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const CountOfBuildings = ({
  buildingsCount,
  isMenuOpen,
  isAsset,
  ...props
}: {
  buildingsCount?: number;
  isMenuOpen?: boolean;
  isAsset?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();

  const checkCountOfBuildings = () => {
    if (buildingsCount === 1)
      return `${buildingsCount} ${
        isAsset ? "Asset" : t("buildingPassport.building")
      }`;
    else if (Number(buildingsCount) > 1)
      return `${buildingsCount} ${
        isAsset ? "Assets" : t("buildingPassport.buildings")
      }`;
    else return t("buildingPassport.noBuilding");
  };

  if (!buildingsCount) return null;
  return (
    <span
      className={clsx(
        "text-xs font-normal",
        isMenuOpen ? "text-indigo-500" : "text-gray-500",
        props.className
      )}
    >
      {checkCountOfBuildings()}
    </span>
  );
};

export default CountOfBuildings;
